import pubsub from '@viewlift/pubsub';
import React, { useEffect, useState } from 'react';
import Spinner from '../spinner';
import "./style.scss";
const ModuleLoader = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        pubsub.subscribe('apploading', (data) => {
            setIsLoading(data);
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'module-loader-wrapper' }, isLoading ? React.createElement(Spinner, null) : React.createElement(React.Fragment, null))));
};
export default ModuleLoader;
